// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__12mQJ","row":"Node_row__3SPMb","label":"Node_label__xVhBY","footer":"Node_footer__31Qh-"};